(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bub-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bub-countdown')) {
    customElements.define(
      'bub-countdown',
      class extends HTMLElement {
        connectedCallback() {
          this.cutoff = Date.parse(this.dataset.cutoff);
          this.output = this.querySelector('[data-countdown]');
          if (Number.isNaN(this.cutoff) || !this.output) return;

          this.tick();
          this.timer = setInterval(() => this.tick(), 30000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        tick() {
          const remaining = this.cutoff - Date.now();

          if (remaining <= 0) {
            this.closest('.bub-announcement')?.setAttribute('data-expired', '');
            clearInterval(this.timer);
            return;
          }

          const minutes = Math.floor(remaining / 60000);
          const days = Math.floor(minutes / 1440);
          const hours = Math.floor((minutes % 1440) / 60);
          const mins = minutes % 60;

          this.output.textContent = days > 0 ? `${days}d ${hours}h ${mins}m left` : `${hours}h ${mins}m left`;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bub-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bub-hero-video')) {
    customElements.define(
      'bub-hero-video',
      class extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          this.button = this.querySelector('.bub-hero__toggle');
          if (!this.video || !this.button) return;

          this.button.addEventListener('click', () => {
            this.video.paused ? this.play() : this.pause();
          });

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.pause();
        }

        play() {
          this.video.play().catch(() => {});
          this.removeAttribute('data-paused');
          this.button.setAttribute('aria-label', this.button.dataset.pauseLabel);
        }

        pause() {
          this.video.pause();
          this.setAttribute('data-paused', '');
          this.button.setAttribute('aria-label', this.button.dataset.playLabel);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
